import { Card, Collapse, Grid, Title } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import React from 'react'

import { Basic } from './Basic'
import { Controlled } from './Controlled'
import { Disabled } from './Disabled'

export const SwitchComponentsDemo: React.FC = () => {
    const [opened, { toggle }] = useDisclosure(true)
    return (
        <Card withBorder>
            <Title order={2} onClick={toggle}>
                开关
            </Title>
            <Collapse in={opened}>
                <Grid gutter={20}>
                    <Grid.Col span={6}>
                        <Basic />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Controlled />
                    </Grid.Col>
                    <Grid.Col span={6}>
                        <Disabled />
                    </Grid.Col>
                </Grid>
            </Collapse>
        </Card>
    )
}
